module.exports = __webpack_public_path__ + "img/5.6069617f.jpg";